import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AgreementDisclosureRemote } from "../../infrastructure/agreement-disclosure.remote";
import { DisclosureAcceptance } from "../models/agreement-disclosure.model";

/** In-house disclosure acceptance's public API. */
@Injectable({
  providedIn: "root",
})
export class AgreementDisclosureFacade {
  constructor(private readonly remote: AgreementDisclosureRemote) {}

  acceptDisclosure$(code: string): Observable<DisclosureAcceptance> {
    return this.remote.acceptDisclosure(code);
  }
}
